import {useTranslation} from "react-i18next";
import {Grid, Typography} from "@mui/material";
import {StatisticsTranslKey} from "./StatisticsTranslKey";
import {StatisticsOverviewDto} from "../../client/statistics/StatisticsApiClient";
import StatTile from "./StatTile";

export interface StatisticsOverviewPanelProps {
    data: StatisticsOverviewDto;
}

export default function StatisticsOverviewPanel(props: Readonly<StatisticsOverviewPanelProps>) {
    const {data} = props;
    const {t} = useTranslation();

    const tiles = [
        {id: StatisticsTranslKey.OPEN_FORM_SESSIONS_COUNT, value: data.openFormSessionsCount, label: t(StatisticsTranslKey.OPEN_FORM_SESSIONS_COUNT)},
        {id: StatisticsTranslKey.TOTAL_FORM_SESSIONS_COUNT, value: data.totalFormSessionsCount, label: t(StatisticsTranslKey.TOTAL_FORM_SESSIONS_COUNT)},
        {id: StatisticsTranslKey.SENT_SUBMISSIONS_COUNT, value: data.sentSubmissionsCount, label: t(StatisticsTranslKey.SENT_SUBMISSIONS_COUNT)},
        {id: StatisticsTranslKey.PUBLISHED_FORMS_COUNT, value: data.publishedFormsCount, label: t(StatisticsTranslKey.PUBLISHED_FORMS_COUNT)},
    ];

    return (
        <>
            <Typography variant="h6" component="h2" sx={{mb: 2}}>
                {t(StatisticsTranslKey.OVERVIEW_TITLE)}
            </Typography>
            <Grid container spacing={2}>
                {tiles.map((tile) => (
                    <Grid item xs={6} md={3} key={tile.id}>
                        <StatTile value={tile.value} label={tile.label}/>
                    </Grid>
                ))}
            </Grid>
        </>
    );
}
